export default __webpack_public_path__ + "static/drill-fa099eac44e3fafbc4ade9684a86087d.png";